//import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@emotion/react";
import { CssBaseline } from "@mui/material";
import { AppProvider } from "./shared/contexts/appContext";

import App from "./App.tsx";
import Theme from "./shared/themes/Theme.ts";
import { AuthProvider } from "./shared/contexts/authContext/index.tsx";
import { ToastContainer } from "react-toastify";

createRoot(document.getElementById("root")!).render(
  <>
    <ThemeProvider theme={Theme}>
      <AuthProvider>
        <AppProvider>
          <CssBaseline />
          <ToastContainer />
          <App />
        </AppProvider>
      </AuthProvider>
    </ThemeProvider>
  </>
);
